var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h2',[_vm._v("New Customers per Month")]),_vm._v(" "),(!_vm.loaded)?_c('p',[_vm._v("\n            Loading...\n        ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"customers-chart"}})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bc5f1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/office/widgets/CustomersChartComponent.vue
// module id = fgcl
// module chunks = 0